module.exports = __webpack_public_path__ + "img/PorkCostaRica.afdce14b.png";